module.exports = __webpack_public_path__ + "static/media/Login_BG.acabe378.png";